<section class="team-view-page">
  <a class="back-link" routerLink="/dashboard/teams">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
    <span>К списку команд</span>
  </a>

  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="loading-state" *ngIf="loading">Загрузка команды...</div>

  <ng-container *ngIf="team && !loading">
    <div class="team-view-grid">
      <aside class="team-sidebar">
        <section class="profile-card">
          <span class="team-logo" [style.background-image]="getLogoBackground()">{{ team.logoUrl ? '' : team.name.charAt(0) }}</span>
          <h1>{{ team.name }}</h1>
          <span>{{ team.championship }}</span>
          <div class="contact-actions">
            <a [href]="team.websiteUrl || null" target="_blank" rel="noopener noreferrer" [class.disabled]="!team.websiteUrl" title="Сайт" aria-label="Сайт">
              <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a14 14 0 0 1 0 18"/><path d="M12 3a14 14 0 0 0 0 18"/></svg>
            </a>
            <a [href]="team.telegramUrl || null" target="_blank" rel="noopener noreferrer" [class.disabled]="!team.telegramUrl" title="Telegram" aria-label="Telegram">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.5 4.5 3 11.8l7 2.2 2.2 7 9.3-16.5Z"/><path d="m10 14 4-4"/></svg>
            </a>
            <a [href]="team.vkUrl || null" target="_blank" rel="noopener noreferrer" [class.disabled]="!team.vkUrl" title="ВКонтакте" aria-label="ВКонтакте">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7c.2 8 4.2 11 8 11h1v-4.2c2.5.3 4.4 2 5.2 4.2H22c-1-2.8-2.7-4.6-4.4-5.3 1.7-1 3.1-2.8 3.7-5.7h-3.2c-.8 2.4-2.5 4.2-5.1 4.4V7H9.8v7.7C7.2 14.1 5.5 12.1 5.3 7Z"/></svg>
            </a>
          </div>
          <a class="primary-link" [routerLink]="['/dashboard/teams', team.slug || team.id, 'edit']">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
            <span>Редактировать</span>
          </a>
          <button class="danger-link" type="button" (click)="deleteTeam()">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>
            <span>Удалить команду</span>
          </button>
        </section>

        <section class="info-card">
          <h2>Детали</h2>
          <dl>
            <div><dt>Чемпионат</dt><dd>{{ team.championship }}</dd></div>
            <div><dt>Город</dt><dd>{{ team.city || 'Не указан' }}</dd></div>
            <div><dt>Основана</dt><dd>{{ team.foundationYear || 'Не указан' }}</dd></div>
            <div><dt>Арена</dt><dd>{{ team.arenaName || 'Не указана' }}</dd></div>
            <div><dt>Вместимость</dt><dd>{{ formatNumber(team.arenaCapacity) }}</dd></div>
            <div><dt>Добавлена</dt><dd>{{ formatDate(team.createdAt) }}</dd></div>
            <div><dt>Изменена</dt><dd>{{ formatDate(team.updatedAt) }}</dd></div>
            <div><dt>Подписчики</dt><dd>{{ team.subscribersTotal }}</dd></div>
          </dl>
        </section>
      </aside>

      <main class="team-content">
        <section class="info-card analytics-card">
          <div class="card-heading analytics-heading">
            <div>
              <h2>Статистика по сезонам</h2>
              <span>Продажи и результаты матчей команды.</span>
            </div>
            <label class="season-select">
              <span>Сезон</span>
              <select class="form-select" [(ngModel)]="selectedSeason">
                <option value="all">Все сезоны</option>
                <option *ngFor="let season of seasons" [value]="season">{{ season }}</option>
              </select>
            </label>
          </div>

          <div class="metrics-grid">
            <article><span>Событий</span><strong>{{ selectedEvents.length }}</strong></article>
            <article><span>Билетов продано</span><strong>{{ soldTicketsTotal }}</strong></article>
            <article><span>Регулярный сезон</span><strong>{{ regularSoldTicketsTotal }}</strong></article>
            <article><span>Плей-офф</span><strong>{{ playoffSoldTicketsTotal }}</strong></article>
            <article><span>Выручка</span><strong>{{ formatMoney(revenueTotal) }}</strong></article>
          </div>
        </section>

        <section class="info-card">
          <h2>Эффективные матчи</h2>
          <div class="best-events">
            <article>
              <span>По количеству билетов</span>
              <ng-container *ngIf="mostTicketsEvent as ticketsEvent; else noTicketsEvent">
                <strong>{{ getEventName(ticketsEvent) }}</strong>
                <small>{{ ticketsEvent.soldTicketsTotal }} билетов</small>
              </ng-container>
            </article>
            <article>
              <span>По выручке</span>
              <ng-container *ngIf="mostRevenueEvent as revenueEvent; else noRevenueEvent">
                <strong>{{ getEventName(revenueEvent) }}</strong>
                <small>{{ formatMoney(revenueEvent.soldRevenue) }}</small>
              </ng-container>
            </article>
          </div>
          <ng-template #noTicketsEvent><strong>Событий пока нет</strong></ng-template>
          <ng-template #noRevenueEvent><strong>Событий пока нет</strong></ng-template>
        </section>

        <section class="info-card">
          <div class="card-heading"><div><h2>События команды</h2><span>Матчи за выбранный сезон.</span></div></div>
          <div class="events-list" *ngIf="selectedEvents.length > 0; else noEvents">
            <a class="event-row" *ngFor="let event of selectedEvents" [routerLink]="['/dashboard/events', event.slug || event.id]">
              <div><strong>{{ getEventName(event) }}</strong><span>{{ formatDate(event.startsAt) }} · {{ event.seasonName }} · {{ event.seasonType === 'regular' ? 'Регулярный сезон' : 'Плей-офф' }}</span></div>
              <div class="event-values"><strong>{{ event.soldTicketsTotal }} билетов</strong><span>{{ formatMoney(event.soldRevenue) }}</span></div>
            </a>
          </div>
          <ng-template #noEvents><p class="muted">Для этой команды пока не создано ни одного события.</p></ng-template>
        </section>
      </main>
    </div>
  </ng-container>
</section>
